import breakpoints from './breakpoints.json';

/** Shared with tailwind.config.js, which reads the same JSON as its `screens`. */
export const BREAKPOINTS = breakpoints;

export type Breakpoint = keyof typeof breakpoints;

export const mediaUp = (key: Breakpoint) => `(min-width: ${BREAKPOINTS[key]}px)`;
export const mediaBelow = (key: Breakpoint) => `(max-width: ${BREAKPOINTS[key] - 1}px)`;

/** Below this the rail becomes a drawer and overlays replace docked panels. */
export const MOBILE_BREAKPOINT: Breakpoint = 'md';

/** Below this the chat floats instead of taking a column, and is never open by default. */
export const CHAT_DOCK_BREAKPOINT: Breakpoint = 'xl';

export const LAYOUT = {
  SIDEBAR_WIDTH_EXPANDED: 280,
  SIDEBAR_WIDTH_MINI: 68,
  HEADER_HEIGHT: 64,
  MAIN_CONTENT_MAX_WIDTH: 1400,
  ULTRA_WIDE_MIN: 1920,
} as const;

export const CHAT_PANEL = {
  MIN_WIDTH: 280,
  MAX_WIDTH: 800,
  DEFAULT_WIDTH: 400,
  WIDTH_BY_BREAKPOINT: { xl: 400, '2xl': 460 },
  KEYBOARD_STEP: 16,
  KEYBOARD_STEP_LARGE: 64,
} as const;

/** MUI owns 1100–1500, so anything shadcn portals to <body> has to clear it. */
export const Z_INDEX = {
  SIDEBAR: 1100,
  HEADER: 1100,
  CHAT_PANEL: 1200,
  CHAT_RESIZE_HANDLE: 1201,
  /** Strictly ABOVE the portal layer (z-portal, 1400), not level with it.
      Radix portals mount at the end of <body>, after #root, so an equal
      z-index loses to them on DOM order — which put every error toast behind
      the dialog whose failure it was reporting. */
  NOTIFICATION: 1500,
} as const;

export const TRANSITION = {
  EASE: 'cubic-bezier(0.2, 0, 0, 1)',
  DURATION_MS: 200,
} as const;
